import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../../../base';

export const StatusFilterContainer = styled.div`
    width: 320px;
    max-height: 80vh;
    overflow-y: auto;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
`;

export const Title = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
    margin-bottom: 4px;
`;

export const Subtitle = styled.div`
    font-size: 12px;
    color: ${Variables.Colors.n70};
    line-height: 1.4;
`;

export const ResetButton = styled.button`
    background: none;
    border: none;
    color: ${Variables.Colors.b300};
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 0;

    &:hover {
        color: ${Variables.Colors.b400};
    }
`;

export const FilterSection = styled.div`
    margin-bottom: 24px;
`;

export const FilterRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid ${Variables.Colors.n15};

    &:last-child {
        border-bottom: none;
    }
`;

export const FilterLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const IconWrapper = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Variables.Colors.n70};
`;

export const FilterName = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: ${Variables.Colors.n100};
`;

export const FilterValue = styled.div`
    font-size: 12px;
    color: ${Variables.Colors.n70};
`;

export const PrioritySection = styled.div`
    margin-bottom: 24px;
    padding-top: 8px;
    border-top: 1px solid ${Variables.Colors.n15};
`;

export const PriorityHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const SectionTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
`;

export const ClearButton = styled.button`
    background: none;
    border: none;
    color: ${Variables.Colors.n70};
    font-size: 12px;
    cursor: pointer;
    padding: 0;

    &:hover {
        color: ${Variables.Colors.n100};
    }
`;

export const PriorityGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
`;

export const PriorityItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const PriorityTag = styled.div`
    font-size: 11px;
    color: ${Variables.Colors.n70};
    margin-left: 24px;
`;

export const AssigneesSection = styled.div`
    padding-top: 8px;
    border-top: 1px solid ${Variables.Colors.n15};
`;

export const AssigneesHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const SearchWrapper = styled.div`
    position: relative;
    margin-bottom: 12px;

    input {
        padding-left: 32px;
        font-size: 13px;
    }
`;

export const SearchIcon = styled(Icon)`
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: ${Variables.Colors.n50};
    pointer-events: none;
`;

export const AssigneesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const AssigneeItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
`;

export const AssigneeAvatar = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background: ${Variables.Colors.n30};
    color: ${Variables.Colors.n70};
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const AssigneeName = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n100};
`;
